module.exports = __webpack_public_path__ + "img/電気回路_2_3_5.ab534f6a.png";